import axios from 'axios';
import { SYMFONY_API_BASE_URL } from '@config/apiConfig';
const claimIdentityProvider = (provider, accessToken) => {
    return axios.post(`${SYMFONY_API_BASE_URL}/api/user/v1/claim_identity_provider`, { provider, accessToken });
};
export default claimIdentityProvider;
